export default {
  name: '机构管理',
  permissionsKey:"YY-JGGL",
  icon: 'fa fa-institution',
  children: {
    examList:{
      name: '机构列表',
      permissionsKey:"YY-JGGL-JGLB",
      path: '/org_manage/org_list',
    },
  }
};
